<template>
    <div>
        <v-btn 
            @click="downloadPDF"
            color="midnight"
            flat
            icon="mdi-download"
            class="iconButton_midnight"
            :ripple="false"
        >
            <v-img 
                alt="Download PDF button please"
                :src=atradiusDownloadIcon class="download-icon"/>
        </v-btn>
    </div>
</template>

<script>
import atradiusDownloadIcon from '@/assets/icons/atradius-download.svg';
import {getStaticResourcesPath} from '../services/dataHandlerService';
export default {
    name: 'DownloadPdfButton',
    data() {
        return {
            atradiusDownloadIcon: atradiusDownloadIcon
        };
    },
    methods: {
        downloadPDF(){
            // Print the page as a PDF
            // window.print();
            // get the PDF file: getStaticResourcesPath() + '/atradius-country-risk-map.pdf'
            const pdfUrl = getStaticResourcesPath() + '/atradius-country-risk-map.pdf';
            window.open(pdfUrl, '_blank');

            
        }
    }
}
</script>

<style scoped>    
    .download-pdf-button .v-btn {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        font-size: 12px;
        z-index: 2000;
    }
    .download-icon {
        width: 20px;
        height: 20px;
    }

    /*media queries*/
    /*mobile*/
    @media only screen and (max-width: 900px) {
        .download-pdf-button .v-btn {
           z-index: 1;
        }
       
    }
</style>